module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/common/add-invitation/add-invitation.component.scss
// module id = ./src/app/modules/backstage-module/common/add-invitation/add-invitation.component.scss
// module chunks = 9